import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";

import Home from "./Pages/Home";
import About from "./Pages/About";
import Services from "./Pages/Services";
import ApplyForJob from "./Pages/ApplyForJob";
import ApplyJob from "./Pages/ApplyJob";
import ApplyReservation from "./Pages/ApplyReservation";
import ContactPage from "./Pages/ContactPage";
import WebServic from "./Pages/WebServic";
import GraphicServic from "./Pages/GraphicServic";
import MotionServic from "./Pages/MotionServic";
import CertifcatePage from "./Pages/CertifcatePage";
import MainContributors from "./Pages/MainContributors";
import Career from "./Pages/Career";
import Portfolio from "./Pages/Portfolio";
import FAQa from "./Pages/FAQa";
import Cookies from "./Pages/Cookies";
import Privacy from "./Pages/Privacy";
import AdminPanel from "./Pages/AdminPanel";
import Login from "./Pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Reservation from "./Pages/Reservation";
import ApplicationSuccess from "./Pages/ApplicationSuccess";
import ApplicationError from "./Pages/ApplicationError";

import WhatsAppWidget from "./components/WhatsAppWidget";
import ScrollToTop from "./components/ScrollToTop";
import PageLoader from "./components/PageLoader";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./AdminPanel.css";
import "./App.css";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    // Wait for all page resources (images, fonts, etc.) to fully load
    const handleLoad = () => {
      // Start fade-out animation
      setIsFading(true);
      // Remove loader after fade-out completes (600ms)
      setTimeout(() => setIsLoading(false), 600);
    };

    if (document.readyState === "complete") {
      // Page already loaded (e.g. hot reload)
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
      return () => window.removeEventListener("load", handleLoad);
    }
  }, []);

  return (
    <>
      {/* Global page loader — shown until all content & images are ready */}
      {isLoading && <PageLoader isFading={isFading} />}

      <Router>
        <ScrollToTop />

        {/* ✅ Toast must be mounted globally OUTSIDE Routes */}
        <ToastContainer
          position="top-right"
          autoClose={2500}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          pauseOnHover
          theme="colored"
        />

        <Routes>
          {/* Main routes */}
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/Services" element={<Services />} />
          <Route path="/ApplyForJob" element={<ApplyForJob />} />
          <Route path="/Contact" element={<ContactPage />} />
          <Route path="/Login" element={<Login />} />

          {/* Services pages */}
          <Route path="/WebServic" element={<WebServic />} />
          <Route path="/GraphicServic" element={<GraphicServic />} />
          <Route path="/MotionServic" element={<MotionServic />} />

          {/* Other pages */}
          <Route path="/CertifcatePage" element={<CertifcatePage />} />
          <Route path="/FAQa" element={<FAQa />} />
          <Route path="/ApplyJob/:id" element={<ApplyJob />} />
          <Route path="/ApplyReservation/:id" element={<ApplyReservation />} />
          <Route path="/Cookies" element={<Cookies />} />
          <Route path="/Privacy" element={<Privacy />} />
          <Route path="/MainContributors" element={<MainContributors />} />
          <Route path="/Career" element={<Career />} />
          <Route path="/Portfolio" element={<Portfolio />} />
          <Route path="/Future-Reservation" element={<Reservation />} />
          <Route path="/application-success" element={<ApplicationSuccess />} />
          <Route path="/application-error" element={<ApplicationError />} />

          {/* 🔒 Protected Admin Panel */}
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            }
          />

          {/* Redirect unknown routes */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>

      {/* Floating WhatsApp */}
      <WhatsAppWidget />
    </>
  );
}

export default App;